import {
  type FieldValues,
  useForm,
  type UseFormProps,
  type UseFormReturn,
  useFormState
} from 'react-hook-form';

import { valibotResolver } from '@hookform/resolvers/valibot';

export const useAppForm = <T extends FieldValues>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- valibot schema type; strict typing breaks useForm resolver inference
  schema: any,
  props?: Omit<UseFormProps<T>, 'resolver'>
) =>
  useForm<T>({
    mode: 'all',
    resolver: valibotResolver(schema),
    ...props
  });

export const useAppFormWithValidation = <T extends FieldValues>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- valibot schema type
  schema: any,
  props?: Omit<UseFormProps<T>, 'resolver'>
) => {
  const formContext = useAppForm<T>(schema, props);
  const { isValid } = useFormState({ control: formContext.control });
  return { ...formContext, isValid } as UseFormReturn<T> & { isValid: boolean };
};

export {
  useFormContext as useAppFormContext,
  useFormState as useAppFormState,
  useWatch as useAppWatch
} from 'react-hook-form';
export { useForm as useAppFormMui } from 'react-hook-form-mui';
